function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGlobe = function SvgGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.3 1.4C8.2 1.1 9.1 1 10 1c3.5 0 6.6 2 8.1 5 .6 1.2.9 2.6.9 4 0 2.7-1.2 5.1-3 6.7-.1.1-.2.2-.3.2-1.5 1.3-3.5 2.1-5.7 2.1-3.4 0-6.4-1.9-7.9-4.7C1.4 13 1 11.5 1 10c0-4 2.7-7.5 6.3-8.6zM9.9 17c1-1.5.6-4-.9-4-2 0-2-1-2-2 0-.8-2-1-3-1-.2-1 0-3 2-3 1.5 0 2-.5 2-1.5S8.5 4 9.5 4c.9 0 1.6-.3 2-.8-.5-.1-1-.2-1.5-.2-3.9 0-7 3.1-7 7 0 3.8 3.1 6.9 6.9 7zm5-2.1c-.4-.4-.9-.9-.9-1.9 0-.5-.5-1-1-1-1.5 0-2-.5-2-2 0-1.2 1.3-1.8 2-2 0-.7.4-2 2-2h.7c.8 1.1 1.3 2.5 1.3 4 0 1.9-.8 3.7-2.1 4.9z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgGlobe;